module.exports = __webpack_public_path__ + "static/media/lt.781d68ef.svg";